import { isEqual } from 'lodash';

import { CategoryOption, DeliveryTime } from '../../api/api';

function isDeliveryTimeEqual(a: DeliveryTime, b: DeliveryTime, useTimeSpan: boolean) {
  const minMaxEqual = a.min === b.min && a.max === b.max;

  if (!useTimeSpan || !a.timespan || !b.timespan) {
    return minMaxEqual;
  }

  return minMaxEqual && isEqual(a.timespan, b.timespan);
}

export function checkIfAnyDeliveryTimeIsUnique(options: CategoryOption[], useTimespan: boolean) {
  const deliveryTimes = options.map(option => option.delivery_times[0]);

  return deliveryTimes.some(deliveryTime => {
    return !isDeliveryTimeEqual(deliveryTime, deliveryTimes[0], useTimespan);
  });
}
